if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}
Shopify.theme.jsAjaxCart = {
  openClassHolderElement: document.body,
  init: function () {
    this.loadCartContents();
    this.event_open = new Event('e_ajax-cart-opened');
    this.event_change = new Event('e_ajax-cart-changed');
    this.event_before_remove = new Event('e_ajax-cart-before-remove');
    this.event_removed = new Event('e_ajax-cart-removed');
    this.event_closed = new Event('e_ajax-cart-closed');
  },
  addCartEvents: function () {
    [...document.querySelectorAll('[data-ajax-cart-trigger]')].forEach(el => {
      el.addEventListener('click', this.openCart.bind(this));
    });
    [...document.querySelectorAll('[data-ajax-cart-close], .ajaxcart__background-overlay')].forEach(el => {
      el.addEventListener('click', this.closeCart.bind(this));
    });
  },
  loadCartContents: async function () {
    fetch('/cart?view=ajax').then(response => response.text()).then(html => {
      const cartContainer = document.querySelector('[data-ajax-cart-contents]');
      if (cartContainer) {
        cartContainer.innerHTML = html;
        const newCartFooter = cartContainer.querySelector('.ajaxcart__content .cart__footer'),
          oldCartFooter = document.querySelector('.cart__footer.cart__total__block');
        if (oldCartFooter && newCartFooter) {
          oldCartFooter.innerHTML = newCartFooter.innerHTML;
          newCartFooter.classList.add('hidden');
        }
        this.addLineEvents();
        this.addCartEvents();
        if (document.querySelector('[data-ajax-cart-contents] form').hasAttribute('data-bundle-in-cart')) {
          window.Shopify.theme.jsLoadScript(document.querySelector('[data-ajax-cart-contents] form').dataset.bundleScript, () => {
            if (!document.querySelector('body').classList.contains('template__product')) Shopify.theme.jsBundleBuilder.init();
          });
        }
        document.dispatchEvent(this.event_change);
      }
    }).catch(error => console.error(`AJAX Cart load error: ${error}`));
  },
  addLineEvents: function () {
    [...document.querySelectorAll('[data-cart-item-quantity]')].forEach(qty => {
      qty.addEventListener('change', this.changeQty);
    });
    [...document.querySelectorAll('[data-cart-item-remove]')].forEach(button => {
      button.addEventListener('click', this.removeLineItem);
    });
  },
  changeQty: event => {
    var item = event.currentTarget,
      params = JSON.stringify({
        line: item.dataset.cartItemIndex,
        quantity: item.value
      });
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: params
    }).then(response => response.json()).then(data => {
      [...document.querySelectorAll(`[data-cart-item-quantity][data-cart-item-index="${item.dataset.cartItemIndex}"]`)].forEach(qty => {
        qty.value = item.value;
      });
      Shopify.theme.jsAjaxCart.onCartChange(data);
    }).catch(error => console.error(`AJAX Cart quantity change error: ${error}`));
  },
  removeLineItem: function (event) {
    var item = event.currentTarget,
      params = JSON.stringify({
        line: item.dataset.cartItemIndex,
        quantity: 0
      });
    Shopify.theme.jsAjaxCart.beforeCartItemRemove(item);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: params
    }).then(response => response.json()).then(data => {
      // animate removal of line item (ajax and page)
      document.querySelectorAll(`[data-cart-item][data-cart-item-index="${item.dataset.cartItemIndex}"]`).forEach(item => item.remove());
      Shopify.theme.jsAjaxCart.onCartItemRemoved();
      Shopify.theme.jsAjaxCart.onCartChange();
    }).catch(error => console.error(`AJAX Cart item remove error: ${error}`));
  },
  onCartChange: function (data) {
    if (data === undefined) {
      this.loadCartContents();
    } else {
      // Update line item subtotals
      // ...
      // Update cart total
      document.querySelectorAll('[data-cart-total]').forEach(total => total.innerText = Utils.formatMoney(data.total_price / 100));
      document.dispatchEvent(this.event_change);
    }
    if (typeof Shopify.theme.jsCartCounter !== 'undefined') {
      Shopify.theme.jsCartCounter.update();
    }
  },
  openCart: function () {
    if (this.openClassHolderElement.classList.contains('ajax-cart-is-open')) return;
    this.openClassHolderElement.classList.add('ajax-cart-is-open');

    // refresh cart
    this.loadCartContents();

    // issue 'e_ajax-cart-opened' event
    this.onCartOpen();
  },
  closeCart: function () {
    this.openClassHolderElement.classList.remove('ajax-cart-is-open');
    this.onCartClose();
  },
  beforeCartItemRemove: function (item) {
    document.dispatchEvent(this.event_before_remove);
  },
  onCartOpen: function () {
    document.dispatchEvent(this.event_open);
  },
  onCartClose: function () {
    document.dispatchEvent(this.event_closed);
  },
  onCartItemRemoved: function () {
    document.dispatchEvent(this.event_removed);
  }
};
(() => {
  Shopify.theme.jsAjaxCart.init();
  document.body.classList.add('js-cart-opening-enabled');
})();
